module.exports = __webpack_public_path__ + "static/media/cayoLargo.a763e922.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/cayoLargo.jpg
// module id = 215
// module chunks = 0